<template>
    <div class="content">
        <div class="container-fluid">
            <div class="row align-items-center mb-1">
                <div class="col-md-6">
                    <div class="h2">Add FAQ</div>
                </div>
                <div class="col-md-2 offset-md-4 text-right center">
                    <router-link to="/admin/faqs" class="btn btn-primary" role="button">
                        back
                    </router-link>
                </div>
            </div>
            <form @submit.prevent="createFaq" v-if="faq">
                <div class="row justify-content-md-center">
                    <div class="col-12">
                        <div class="row">
                            <div class="col-md-12" v-if="faqSections.length">
                                <fg-select
                                  v-model="faq.faqHeaderId"
                                  label="Select Section Header"
                                  v-validate="rules.faqHeaderId"
                                  data-vv-name="Section Header"
                                  cus-name="Section Header"
                                  :has-errors="errors"
                                  :is-fields="fields"
                                  :list="faqSections"
                                  selectedKey="faqHeaderId"
                                  showLabel="faqHeader"
                                >
                                </fg-select>
                            </div>
                          <div class="col-md-5">
                            <fg-input type="text"
                                      v-model="faq.faqImageUrl"
                                      label="Image URL"
                                      placeholder="Enter Image URL"
                                      data-vv-name="imageUrl"
                                      cus-name="imageUrl"
                                      v-validate="rules.faqImageUrl"
                                      :has-errors="errors"
                                      :is-fields="fields"
                            >
                            </fg-input>
                          </div>
                          <div class="col-md-5">
                            <fg-input type="text"
                                      v-model="faq.faqVideoUrl"
                                      label="Video Code"
                                      placeholder="Enter Video Code"
                                      data-vv-name="Video Code"
                                      cus-name="Video Code"
                                      v-validate="rules.faqVideoUrl"
                                      :has-errors="errors"
                                      :is-fields="fields"
                            >
                            </fg-input>
                          </div>
                          <div class="col-md-12">
                            <fg-text-area type="text"
                                      v-model="faq.question"
                                      label="Question"
                                      placeholder="Enter Question"
                                      v-validate="rules.question"
                                      data-vv-name="Question"
                                      cus-name="Question"
                                      :has-errors="errors"
                                      :is-fields="fields">
                            </fg-text-area>
                          </div>
                          <div class="col-md-12">
                            <fg-text-area type="text"
                                      v-model="faq.response"
                                      label="Answer"
                                      placeholder="Enter Answer"
                                      v-validate="rules.response"
                                      data-vv-name="Answer"
                                      cus-name="Answer"
                                      :has-errors="errors"
                                      :is-fields="fields">
                            </fg-text-area>
                          </div>
                          </div>
                            <!--<div class="col-3" v-if="status.length">-->
                              <!--<fg-select-->
                                <!--v-model="article.active"-->
                                <!--label="isActive"-->
                                <!--v-validate="rules.active"-->
                                <!--data-vv-name="active"-->
                                <!--cus-name="active"-->
                                <!--:has-errors="errors"-->
                                <!--:is-fields="fields"-->
                                <!--:list="status"-->
                                <!--selectedKey="id"-->
                              <!--&gt;-->
                              <!--</fg-select>-->
                            <!--</div>-->
                        </div>
                    <div class="col-6 text-center">
                        <button type="submit" :disabled="errors.any()" class="btn btn-primary btn-fill btn-block">
                            Create FAQ
                        </button>
                    </div>
                </div>
                <div class="clearfix"></div>
            </form>
        </div>
    </div>
</template>
<script>
    import { mapGetters } from 'vuex'
    import moment from 'moment'
    export default {
        name: 'CreateFAQ',
        created (){
    },
    data () {
        return {
            showMore: false,
            faq: {
              faqHeaderId: '',
              question: '',
              response: '',
              faqImageUrl: '',
              faqVideoUrl: '',
              active: 1
            },
            active: 1,
            status: [{name:'Select Status'}, {id:"1", name:'Active'}, {id:"0", name:'Inactive'}],
            rules: {
              faqHeaderId: {required : true},
              question: {required: true},
              response: {required : true}
            },
            faqSections: [],
            message: {
                error: false,
                text: ''
            }
        }
    },
    methods: {
      fetchFAQSections () {
        this.$store.dispatch('FETCH_FAQSECTIONS')
          .then((res) => {
            res.unshift({faqHeader: "Select an option"});
            this.faqSections = res;
            console.log('sections', this.faqSections)
          })
          .catch(err => {
            console.log("API error : ", err);
          })
          , (err) => {
          console.log("err : ", err);
        }
      },
        createFaq () {
          console.log("this.article : ", this.faq);
          this.$validator.validateAll().then((result) => {
            if(result){
              this.$store.dispatch('ADD_FAQ', this.faq)
                .then((res) => {
                  console.log("ADD_FAQ res : ", res);
                  if(res) this.showPopup('Success!', 'FAQ is successfully created', 'success', ()=>this.$router.push('/admin/faqs'))
                  else this.showPopup('Error!', 'Unable to process.', 'error')
                })
                .catch(err => {
                  this.showPopup('Error!', 'some thing happen wrong', 'error')
                  console.log("ADD_ARTICLE API error : ", err);
                })
            }
          })
        },
        showPopup(title, msg, popupType, cb){
            this.$swal( title, msg, popupType
            ).then(res => {
                        cb && cb();
                        return res
                    })
        }
    },
    created() {
    this.fetchFAQSections();
    }
    }
</script>

<style>
    .form-control{
        height: 100%;
    }
</style>



// WEBPACK FOOTER //
// src/components/Dashboard/Views/Faqs/CreateFaq.vue